/* OH GOOGLE TRACKING FIX v2 (post-migración 16 mar 2026)
   Externalised from inline snippet for perf. Reads window.OH_TRK_DATA
   (set by inline stub in head) for cart/customer values. */
(function () {
  'use strict';
  if (window.OH_TRACKING_FIX_LOADED) return;
  window.OH_TRACKING_FIX_LOADED = true;

  var d = window.OH_TRK_DATA || {};
  var cartValue = d.cartValue || 0;
  var currency = d.currency || 'EUR';
  var cartItems = d.cartItems || [];
  var ecUserData = d.ecUserData || null;

  var GOOGLE_ADS_ID         = 'AW-963206514';
  var BEGIN_CHECKOUT_LABEL  = 'AW-963206514/shC0CKD3-v8bEPK6pcsD';
  var VIEW_ITEM_LABEL       = 'AW-963206514/o8NJCKn3-v8bEPK6pcsD';
  var PURCHASE_LABEL        = 'AW-963206514/Kc_qCJ33-v8bEPK6pcsD';
  var ADD_TO_CART_LABEL     = 'AW-963206514/FKH3CKP3-v8bEPK6pcsD';
  var ADD_PAYMENT_LABEL     = 'AW-963206514/YKgJCK_3-v8bEPK6pcsD';
  var BLOCKED_TAG_IDS = ['G-5NFLGKWWWM', 'G-PMMXTNXJ3C'];

  function ts(){return new Date().toISOString();}
  function log(t,d){try{console.debug('[OH-TRACK '+ts()+'] '+t,d||'');}catch(e){}}

  function installGtagFilter() {
    var origGtag = window.gtag;
    if (typeof origGtag !== 'function') {
      setTimeout(installGtagFilter, 500);
      return;
    }
    if (window.gtag.__OH_PATCHED) return;
    window.gtag = function() {
      var args = Array.prototype.slice.call(arguments);
      try {
        if (args[0] === 'config' && BLOCKED_TAG_IDS.indexOf(args[1]) !== -1) {
          log('blocked config', args[1]);
          return;
        }
        if (args[0] === 'event' && args[2] && args[2].send_to) {
          var sendTo = args[2].send_to;
          var sendToList = Array.isArray(sendTo) ? sendTo : [sendTo];
          var filtered = sendToList.filter(function(t) {
            for (var i = 0; i < BLOCKED_TAG_IDS.length; i++) {
              if (t === BLOCKED_TAG_IDS[i] || t.indexOf(BLOCKED_TAG_IDS[i] + '/') === 0) return false;
            }
            return true;
          });
          if (filtered.length === 0) { log('blocked event', args[1]); return; }
          if (filtered.length !== sendToList.length) {
            args[2] = Object.assign({}, args[2], { send_to: filtered.length === 1 ? filtered[0] : filtered });
          }
        }
      } catch(e) { log('filter err', e.message); }
      return origGtag.apply(this, args);
    };
    window.gtag.__OH_PATCHED = true;
    log('gtag filter installed');
  }
  installGtagFilter();
  setTimeout(installGtagFilter, 1000);
  setTimeout(installGtagFilter, 3000);

  function fireBeginCheckout() {
    log('fireBeginCheckout', { value: cartValue, items: cartItems.length });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: { currency: currency, value: cartValue, items: cartItems }
    });
    if (typeof window.gtag === 'function') {
      try {
        var conv = { send_to: BEGIN_CHECKOUT_LABEL, value: cartValue, currency: currency };
        if (ecUserData) conv.user_data = ecUserData;
        window.gtag('event', 'conversion', conv);
        window.gtag('event', 'begin_checkout', { currency: currency, value: cartValue, items: cartItems });
      } catch(e) { log('gtag err', e.message); }
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('checkout_started_oh_fallback', {
          checkout: {
            currencyCode: currency,
            totalPrice: { amount: cartValue, currencyCode: currency },
            lineItems: cartItems.map(function(i){
              return {
                quantity: i.quantity,
                title: i.item_name,
                variant: { id: String(i.item_id), price: { amount: i.price, currencyCode: currency } }
              };
            })
          }
        });
      }
    } catch(e) { log('shopify publish err', e.message); }
  }

  function bind() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      // SubmitEvent identifies the actual button, including buttons outside the
      // form associated by form="...". Other submit actions are not checkout.
      if (e.submitter) {
        if (e.submitter.name === 'checkout') fireBeginCheckout();
        return;
      }
      // Preserve the previous fallback for browsers/programmatic submits that
      // supply no submitter; public validation must confirm this legacy path.
      if (form.querySelector('button[name="checkout"], input[name="checkout"]')) {
        fireBeginCheckout();
      }
    }, true);
    document.addEventListener('click', function(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('a[href*="/checkouts"], a[href*="checkout.shopify.com"]');
      if (link) fireBeginCheckout();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
